<template>
  <div v-if="visible" class="app-main-inner">
    <el-form
      :disabled="readonly"
      class="section"
      style="flex-direction: row"
    >
      <el-checkbox v-model="form.booking" no="booking">{{ $t('SeaExport.Booking') }}</el-checkbox>
      <el-checkbox
        v-model="form.customs"
        no="customs"
        style="margin-left: -20px"
        @change="val=>{form.customsBroker=val?form.customsBroker:0;form.customsDeclarationType=val?form.customsDeclarationType:-1}"
      >{{ $t('SeaExport.WhetherDeclarations') }}</el-checkbox>
      <el-checkbox
        v-model="form.insure"
        no="isInsure"
        style="margin-left: -20px;"
      >{{ $t('SeaExport.InsureInfo') }}
      </el-checkbox>
      <el-checkbox v-model="form.vgm" no="vgm" style="margin-left: -20px">{{ $t('SeaExport.Vgm') }}</el-checkbox>
      <el-checkbox v-model="form.ams" no="ams" style="margin-left: -20px;">{{ $t('SeaExport.Anti_terrorismShipping') }}</el-checkbox>
      <el-checkbox v-model="form.batch" no="batch" style="margin-left: -20px">{{ $t('SeaExport.InBatchesOrNot') }}</el-checkbox>
      <el-checkbox v-if="isBookingNew" v-model="form.destinationPortService" no="destinationPortService" style="margin-left: -20px;" @change="syncSlaves('destinationPortService')">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
      <div v-if="!!templateName" style="flex-grow: 1;">
        <span class="blue" style="float: right;margin-right: 30px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
      </div>
    </el-form>
    <tab-booking-master-UICustom-layout :element-blocks="elementBlocks">
      <el-form-item v-if="elementDict.jobNo.viewable" slot="jobNo">
        <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
        <el-input
          :value="form.jobNo"
          :disabled="true"
        />
      </el-form-item>
      <template v-if="isZY">
        <el-form-item slot="saleProductCode">
          <line-label slot="label" class="blue" :label="$t('SeaExport.AllowSaleProduct')" />
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_AllowSaleProduct"
            filterable
            no="allowSaleProduct"
            clearable
            :data-filter-function="p => {
              if (!p.statusEnabled) {
                return false
              }
              return isFba ? p.fbaSea : p.seaExportEnabled
            }"
            :default-value="this.form.saleProductCode || ''"
            :disabled="readonly"
            @parentCallBack="p => {this.form.saleProductCode = p.value}"
          />
        </el-form-item>
        <el-form-item slot="fullOrInside">
          <line-label slot="label" class="blue" :label="$t('SeaExport.FullOrInside')" />
          <cargo-advance-select
            :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
            no="fullOrInside"
            clearable
            :default-value="this.form.fullOrInside || ''"
            :disabled="readonly"
            @parentCallBack="p => {this.form.fullOrInside = p.value}"
          />
        </el-form-item>
      </template>
      <template v-if="form.containerLoadType===BC_CARGO_TYPE.code">
        <el-form-item v-if="elementDict.customerId.viewable" slot="customerId">
          <line-label slot="label" :label="elementDict.customerId.label" />
          <cargo-sales-company-select
            no="customerId"
            class="shipper-selector"
            popper-class="shipper-selector-popper"
            :method-params="{customer:true,companyLob:'seaExport',active:true}"
            :check-credit="true"
            :default-value="form.customerId||''"
            :disabled="readonly || !elementDict.customerId.writable"
            :job="form"
            :latest-used-data-key="elementDict.customerId.userCustomContent && elementDict.customerId.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-customerId' : ''"
            @parentCallBack="customerIdChange"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customerProperty.viewable" slot="customerProperty">
          <line-label slot="label" :class="elementDict.customerProperty.isRequire ? 'blue' : ''" :label="elementDict.customerProperty.label" />
          <el-tooltip :content="customerTip" placement="bottom">
            <span
              v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
              class="orange"
            >LV{{ customerLevel.level }}</span>
            <span
              v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
              style="color:#D3A73B"
            >&nbsp;{{ customerLevel.customerName }}</span>
            <span
              v-show="contractStatusLabel"
              class="red"
            >&nbsp;({{ contractStatusLabel }})</span>
            <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="elementDict.customerContact.viewable" slot="customerContact">
          <line-label slot="label" :class="elementDict.customerContact.isRequire ? 'blue' : ''" :label="elementDict.customerContact.label" />
          <div style="display: flex">
            <el-select
              v-model="form.customerContact"
              :disabled="readonly || !elementDict.customerContact.writable"
              no="customerContact"
              filterable
              :allow-create="true"
            >
              <el-option
                v-for="(item,index) in contactList"
                :key="index"
                :label="item.contactPerson"
                :value="item.contactPerson"
              />
            </el-select>&nbsp;
            <el-link
              v-show="!isShowContactPersonDetail"
              no="customerContactLink"
              :class="form.customerContact?'':'not-click'"
              @click="showContactDialog"
            >{{ $t('SeaExport.Detail') }}
            </el-link>
          </div>
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.containerLoadType.viewable" slot="containerLoadType">
        <line-label slot="label" :class="elementDict.containerLoadType.isRequire ? 'blue' : ''" :label="elementDict.containerLoadType.label" />
        <el-select
          v-model="form.containerLoadType"
          no="containerLoadType"
          :disabled="readonly || !elementDict.containerLoadType.writable"
          @change="pm.selectDefaultCutomJobType();pm.containerLoadTypeChange()"
        >
          <el-option
            v-for="(item,index) in containerLoadTypes"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.bookingDate.viewable" slot="bookingDate">
        <line-label slot="label" :class="elementDict.bookingDate.isRequire ? 'blue' : ''" :label="elementDict.bookingDate.label" />
        <el-date-picker
          v-model="form.bookingDate"
          no="bookingDate"
          :disabled="readonly || !elementDict.bookingDate.writable"
          type="date"
          style="width:100%;"
          clearable
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.etd.viewable" slot="etd">
        <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
        <div style="display: flex">
          <el-date-picker
            no="etd"
            class="departure-date-picker"
            :value="form.etd"
            :disabled="readonly || !elementDict.etd.writable || !isJydEditJobFields"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('SeaExport.RequiredItem')"
            style="flex: 1;margin-right: 5px"
            @input="etdChange"
            @change="onFieldChange('etd')"
          />
          <span>{{ form.sailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.eta.viewable" slot="eta">
        <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.eta"
            no="eta"
            :disabled="readonly || !elementDict.eta.writable"
            style="flex: 1;margin-right: 5px"
            type="date"
            value-format="yyyy-MM-dd"
            @input="etaChange"
          />
          <span>{{ form.etaSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.atd.viewable" slot="atd">
        <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
        <div style="display: flex">
          <el-date-picker
            :value="form.atd"
            no="atd"
            :disabled="readonly || !elementDict.atd.writable"
            style="flex: 1;margin-right: 5px"
            type="date"
            value-format="yyyy-MM-dd"
            @input="atdChange"
          />
          <span>{{ form.atdSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.ata.viewable" slot="ata">
        <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.ata"
            no="ata"
            :disabled="readonly || !elementDict.ata.writable"
            style="flex: 1;margin-right: 5px"
            type="date"
            value-format="yyyy-MM-dd"
            @input="ataChange"
          />
          <span>{{ form.ataSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.customsDate.viewable" slot="customsDate">
        <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
        <el-date-picker
          v-model="form.customsDate"
          no="customsDate"
          type="date"
          :disabled="readonly || !elementDict.customsDate.writable || !isJydUpdateCustomsDate"
          style="width:100%"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.loadingPortCode.viewable" slot="loadingPortCode">
        <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
        <div style="display: flex; justify-content: space-between">
          <cargo-advance-select
            ref="loadingPortCode"
            no="loadingPortCode"
            :disabled="readonly || !elementDict.loadingPortCode.writable"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="form.loadingPortCode"
            tag-name="englishName"
            :placeholder="$t('SeaExport.RequiredItem')"
            style="width:128px;"
            :latest-used-data-key="elementDict.loadingPortCode.userCustomContent && elementDict.loadingPortCode.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-loadingPortCode' : ''"
            @parentCallBack="p=>{pm.loadingPortCodeChange(p);pm.cargoDocChangeHandler()}"
          />
          <template v-if="elementDict.transferPortCode.viewable">
            &nbsp;
            <el-checkbox v-model="form.transfering" :disabled="readonly || !elementDict.loadingPortCode.writable" no="transfering" style="padding-left:2px;" @change="pm.updateSecondVesselInfo()">{{ fieldDict.transfering.label }}</el-checkbox>
          </template>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.transferPortCode.viewable && form.transfering" slot="transferPortCode">
        <line-label slot="label" :class="elementDict.transferPortCode.isRequire ? 'blue' : ''" :label="elementDict.transferPortCode.label" />
        <cargo-advance-select
          no="transferPortCode"
          :disabled="readonly || !elementDict.transferPortCode.writable"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.transferPortCode"
          @parentCallBack="p=>{form.transferPortCode=p.value;pm.updateSecondVesselInfo()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dischargingPortCode.viewable" slot="dischargingPortCode">
        <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
        <cargo-advance-select
          no="dischargingPortCode"
          :disabled="readonly || !elementDict.dischargingPortCode.writable"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.dischargingPortCode"
          :placeholder="$t('SeaExport.RequiredItem')"
          :latest-used-data-key="elementDict.dischargingPortCode.userCustomContent && elementDict.dischargingPortCode.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-dischargingPortCode' : ''"
          @parentCallBack="p=>{pm.dischargingPortCodeChange(p,form.carrierId);pm.cargoDocChangeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPortCode.viewable" slot="destinationPortCode">
        <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
        <cargo-advance-select
          no="destinationPortCode"
          class="port-of-delivery-selector"
          popper-class="port-of-delivery-selector-popper"
          :select-type="selectTypeNames.basic_data_Seaport"
          filterable
          :default-value="form.destinationPortCode"
          :disabled="readonly || !elementDict.destinationPortCode.writable"
          :placeholder="$t('SeaExport.RequiredItem')"
          :latest-used-data-key="elementDict.destinationPortCode.userCustomContent && elementDict.destinationPortCode.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-destinationPortCode' : ''"
          @parentCallBack="p=>{pm.destinationPortCodeChange(p);pm.cargoDocChangeHandler();pm.changeDestinationPort()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.placeOfDeliveryRegion.viewable" slot="placeOfDeliveryRegion">
        <line-label slot="label" :class="elementDict.placeOfDeliveryRegion.isRequire ? 'blue' : ''" :label="elementDict.placeOfDeliveryRegion.label" />
        <cargo-advance-select
          no="placeOfDeliveryRegion"
          :select-type="selectTypeNames.basic_data_Region"
          filterable
          :default-value="form.placeOfDeliveryRegion"
          :disabled="readonly || !elementDict.placeOfDeliveryRegion.writable"
          @parentCallBack="p=>{form.placeOfDeliveryRegion=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transshipmentTransportationModeCode && elementDict.transshipmentTransportationModeCode.viewable" slot="transshipmentTransportationModeCode">
        <line-label slot="label" :class="elementDict.transshipmentTransportationModeCode.isRequire ? 'blue' : ''" :label="elementDict.transshipmentTransportationModeCode.label" />
        <cargo-advance-select
          no="transportationMode"
          :static-options="transportationModeInfos"
          :filter-tag-names="['chineseName', 'englishName', 'code']"
          filterable
          :disabled="readonly || !elementDict.transshipmentTransportationModeCode.writable"
          :tag-name="'englishName'"
          :default-value="form.transshipmentTransportationModeCode"
          @parentCallBack="p=>{form.transshipmentTransportationModeCode=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingAgent.viewable && bookingAgentVisible" slot="bookingAgent">
        <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
        <cargo-company-select
          v-if="!isJoinCarrierBookingAgent||form.containerLoadType==='BB'"
          no="bookingAgent"
          class="booking-agent-selector"
          popper-class="booking-agent-selector-popper"
          :disabled="readonly || !elementDict.bookingAgent.writable || !bookingAgentEnabled"
          :method-params="{bookingAgent:true,active:true}"
          :default-value="form.bookingAgent||''"
          :placeholder="$t('SeaExport.RequiredItem')"
          :latest-used-data-key="elementDict.bookingAgent.userCustomContent && elementDict.bookingAgent.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-bookingAgent' : ''"
          @change="p=>{pm.bookingAgentChange(p)}"
        />
        <cargo-advance-select
          v-if="isJoinCarrierBookingAgent&&form.containerLoadType!=='BB'"
          no="bookingAgent"
          class="booking-agent-selector"
          popper-class="booking-agent-selector-popper"
          :disabled="readonly || !elementDict.bookingAgent.writable || !bookingAgentEnabled"
          :select-type="selectTypeNames.static_data_Company"
          :cache="false"
          filterable
          :default-value="form.bookingAgent||''"
          :static-options="bookingAgentList"
          :placeholder="$t('SeaExport.RequiredItem')"
          :latest-used-data-key="elementDict.bookingAgent.userCustomContent && elementDict.bookingAgent.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-bookingAgent' : ''"
          @parentCallBack="p=>{pm.bookingAgentChange(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.carrierAgentId.viewable" slot="carrierAgentId">
        <line-label slot="label" :class="elementDict.carrierAgentId.isRequire ? 'blue' : ''" :label="elementDict.carrierAgentId.label" />
        <cargo-company-select
          no="carrierAgentId"
          :disabled="readonly || !elementDict.carrierAgentId.writable"
          :method-params="{seaCmpAgent:true,active:true}"
          :default-value="form.carrierAgentId||''"
          @change="p=>{form.carrierAgentId=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.terminalCompany.viewable" slot="terminalCompany">
        <line-label slot="label" :class="elementDict.terminalCompany.isRequire ? 'blue' : ''" :label="elementDict.terminalCompany.label" />
        <cargo-company-select
          no="terminalCompany"
          :method-params="{terminalCompany:true,companyLob:'seaExport',active:true}"
          :default-value="form.terminalCompany||''"
          :disabled="readonly || !elementDict.terminalCompany.writable"
          style="width: 100%"
          @change="p=>{JobUtils.terminalCompanyChangeHandler(form, p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.carrierId.viewable" slot="carrierId">
        <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
        <cargo-company-select
          ref="shippingCompany"
          no="carrierId"
          :disabled="readonly || !elementDict.carrierId.writable || !carrierIdEnabled"
          :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
          :default-value="form.carrierId||''"
          :latest-used-data-key="elementDict.carrierId.userCustomContent && elementDict.carrierId.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-carrierId' : ''"
          @change="p=>{pm.carrierChangeHandler(p, this.scacList, this.carrierScacEdit);}"
        />
      </el-form-item>
      <!-- 船公司SCAC -->
      <el-form-item v-if="elementDict.carrierScac && elementDict.carrierScac.viewable" slot="carrierScac">
        <line-label slot="label" :class="elementDict.carrierScac.isRequire ? 'blue' : ''" :label="elementDict.carrierScac.label" />
        <cargo-advance-select
          no="carrierScac"
          filterable
          :custom-label="(item)=>`[${item.code}]${item.englishName?item.englishName:item.code}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          :static-options="scacList"
          tag-value="code"
          :disabled="readonly || !carrierScacEdit || !elementDict.carrierScac.writable"
          :default-value="form.carrierScac||''"
          :latest-used-data-key="elementDict.carrierScac.userCustomContent && elementDict.carrierScac.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-carrierScac' : ''"
          @parentCallBack="p=>{form.carrierScac = p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSource.viewable" slot="cargoSource">
        <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
        <div style="display: flex; justify-content: space-between">
          <el-select
            v-model="form.cargoSource"
            :disabled="readonly || !elementDict.cargoSource.writable"
            no="cargoSource"
            :placeholder="$t('SeaExport.PleaseSelect')"
            :clearable="false"
            size="mini"
            @change="form.designationAgent=0;pm.cargoSourceChange()"
          >
            <el-option
              v-for="(item,index) in CARGO_SOURCES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.customJobType.viewable" slot="customJobType">
        <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
        <cargo-advance-select
          ref="customJobType"
          no="customJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :default-value="form.customJobType"
          :static-options="customJobTypeList"
          :method-params="{type:form.lob}"
          :disabled="readonly || !elementDict.customJobType.writable"
          @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.secondaryCustomJobType.viewable && form.customJobType && secondaryCustomJobTypeList.length > 0" slot="secondaryCustomJobType">
        <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
        <cargo-advance-select
          ref="secondaryCustomJobType"
          no="secondaryCustomJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :cache="false"
          :default-value="form.secondaryCustomJobType"
          :disabled="readonly || !elementDict.secondaryCustomJobType.writable"
          :tag-name="isZh?'name':'englishName'"
          :static-options="secondaryCustomJobTypeList"
          @parentCallBack="p=>{form.secondaryCustomJobType=p.value}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.destinationAgent.viewable" slot="destinationAgent">
        <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
        <el-tooltip :content="destinationAgentTip" :disabled="!showDestinationAgentWarning" placement="right-end">
          <cargo-company-select
            ref="destinationAgent"
            no="destinationAgent"
            :method-params="{overseaAgent:true,active:true}"
            :check-credit="true"
            :job="form"
            :default-value="form.destinationAgent||''"
            :disabled="readonly || !elementDict.destinationAgent.writable"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            :latest-used-data-key="elementDict.destinationAgent.userCustomContent && elementDict.destinationAgent.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-destinationAgent' : ''"
            @change="p=>{pm.txtDestinationAgentChangeHandler(p)}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.designationAgent.viewable && form.cargoSource==='NC'" slot="designationAgent">
        <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
        <el-tooltip :content="designationAgentTip" :disabled="!showDesignationAgentWarning" placement="right-end">
          <cargo-company-select
            no="designationAgent"
            class="designation-agent-selector"
            popper-class="designation-agent-selector-popper"
            :disabled="readonly || !elementDict.designationAgent.writable || !designationAgentEnabled"
            :method-params="{designationAgent:true,active:true}"
            :check-credit="true"
            :job="form"
            :default-value="form.designationAgent||''"
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"

            @change="p=>{pm.txtDesignationAgentChangeHandler(p)}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.exChangeAgent.viewable" slot="exChangeAgent">
        <line-label slot="label" :class="elementDict.exChangeAgent.isRequire ? 'blue' : ''" :label="elementDict.exChangeAgent.label" />
        <cargo-company-select
          no="exChangeAgent"
          :disabled="readonly || !elementDict.exChangeAgent.writable || !form.destinationPortService"
          :method-params="{bookingAgent:true,active:true}"
          :default-value="form.exChangeAgent||''"
          @change="onExChangeAgentChange"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transportSource.viewable" slot="transportSource">
        <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
        <cargo-advance-select
          filterable
          :select-type="selectTypeNames.basic_data_TransportSource"
          no="transportSource"
          :default-value="form.transportSource"
          :disabled="readonly || !elementDict.transportSource.writable"
          :cache="false"
          tag-value="code"
          placeholder=" "
          @parentCallBack="item=>form.transportSource=item.value"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.statisticArea.viewable" slot="statisticArea">
        <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
        <cargo-advance-select
          filterable
          :select-type="selectTypeNames.basic_data_StatisticArea"
          no="statisticArea"
          :default-value="form.statisticArea"
          :disabled="readonly || !elementDict.statisticArea.writable"
          :cache="false"
          tag-value="code"
          placeholder=" "
          @parentCallBack="item=>form.statisticArea=item.value"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.localService.viewable" slot="localService">
        <line-label slot="label" :class="elementDict.localService.isRequire ? 'blue' : ''" :label="elementDict.localService.label" />
        <el-checkbox
          v-model="form.warehousing"
          :disabled="readonly || !elementDict.localService.writable"
          no="warehousing"
          style="display: block;"
          @change="pm.loadingTermChange('warehousing')"
        >{{ $t('SeaExport.WarehouseLoadingStorage') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.landTransportation"
          :disabled="readonly || !elementDict.localService.writable"
          no="landTransportation"
          style="display: block;"
          @change="pm.loadingTermChange('landTransportation')"
        >{{ $t('SeaExport.DoorLoadingDelivery') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.selfDeliver"
          :disabled="readonly || !elementDict.localService.writable"
          no="selfDeliver"
          style="display: block;"
        >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}
        </el-checkbox>
        <el-checkbox v-model="form.backUpWarehouse" :disabled="readonly || !elementDict.localService.writable" no="backUpWarehouse" @change="pm.backUpWarehouseChange()">{{ $t('SeaExport.BackUpWarehouse') }} </el-checkbox>
      </el-form-item>
      <el-form-item v-if="elementDict.portOfDestinationServices.viewable && !isFba && isBookingNew && form.destinationPortService" slot="portOfDestinationServices">
        <line-label slot="label" :class="elementDict.portOfDestinationServices.isRequire ? 'blue' : ''" :label="elementDict.portOfDestinationServices.label" />
        <el-checkbox
          v-model="form.dischargingPortDoor"
          :disabled="readonly || !elementDict.portOfDestinationServices.writable"
          no="dischargingPortDoor"
          style="display: block;"
        >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.usCustomsClearance"
          :disabled="readonly || !elementDict.portOfDestinationServices.writable"
          no="usCustomsClearance"
          style="display: block;"
        >{{ $t('queryJob.UsCustomsClearance') }}
        </el-checkbox>
        <el-checkbox
          v-model="form.destPortCustomsClearance"
          :disabled="readonly || !elementDict.portOfDestinationServices.writable"
          no="destPortCustomsClearance"
          style="display: block;"
          @change="syncSlaves('destPortCustomsClearance')"
        >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
        </el-checkbox>
      </el-form-item>
      <el-form-item
        v-if="elementDict.customerRefNo.viewable"
        id="customerRefNo"
        slot="customerRefNo"
      >
        <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
        <el-tooltip
          :disabled="!customerRefNoTip"
          :content="customerRefNoTip"
          placement="right-end"
        >
          <el-input
            v-model="form.customerRefNo"
            :disabled="readonly || !elementDict.customerRefNo.writable"
            no="customerRefNo"
            :class="customerRefNoTip?'red':''"
            @blur="pm.customerRefNoFocusOutHandler()"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.agentRefNo.viewable && form.cargoSource === 'NC'" id="agentRefNo" slot="agentRefNo">
        <line-label slot="label" :class="elementDict.agentRefNo.isRequire ? 'blue' : ''" :label="elementDict.agentRefNo.label" />
        <el-input v-model="form.agentRefNo" :disabled="readonly || !elementDict.agentRefNo.writable" no="agentRefNo" />
      </el-form-item>
      <el-form-item v-if="elementDict.poNo.viewable" slot="poNo" :class="poNoRed?'poNoClass':''">
        <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
        <el-input v-model="form.poNo" :disabled="readonly || !elementDict.poNo.writable" no="poNo" />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTerm.viewable" slot="freightTerm">
        <line-label slot="label" :class="elementDict.freightTerm.isRequire ? 'blue' : ''" :label="elementDict.freightTerm.label" />
        <cargo-advance-select
          no="freightTerm"
          :select-type="selectTypeNames.basic_data_ShippingTerm"
          filterable
          :default-value="form.freightTerm"
          :disabled="readonly || !elementDict.freightTerm.writable"
          @parentCallBack="p=>{form.freightTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermMBL.viewable" slot="paymentTermMBL">
        <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
        <cargo-advance-select
          no="paymentTermMBL"
          :disabled="readonly || !elementDict.paymentTermMBL.writable"
          :select-type="selectTypeNames.basic_data_PaymentTerm"
          filterable
          :default-value="form.paymentTermMBL"
          @parentCallBack="p=>{form.paymentTermMBL=p.value;pm.paymentTermMBLChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customsBroker.viewable" slot="customsBroker">
        <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
        <cargo-company-select
          no="customsBroker"
          :disabled="readonly || !elementDict.customsBroker.writable || !customsBrokerEnabled"
          :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
          :default-value="form.customsBroker||''"
          :placeholder="$t('SeaExport.PleaseTickCustomsDeclarationOption')"

          :data-filter-function="customsBrokerFilter"
          @change="p=>{pm.customsBrokerChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customsDeclarationType.viewable" slot="customsDeclarationType">
        <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
        <cargo-advance-select
          no="customsDeclarationType"
          :disabled="readonly || !elementDict.customsDeclarationType.writable || !customsBrokerEnabled"
          :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
          filterable
          :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
          :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
          @parentCallBack="p=>{form.customsDeclarationType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="isFba" :label="$t('SeaExport.CustomsDeclarationMethod')">
        <cargo-advance-select
          no="customsMethodPol"
          :disabled="readonly || !elementDict.customsMethodPol.writable"
          :select-type="selectTypeNames.basic_data_CustomsMode"
          :method-params="{serviceType:0}"
          filterable
          :clearable="false"
          :default-value="fbaJob.customsMethodPol"
          @parentCallBack="p=>{fbaJob.customsMethodPol=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="isFba" :label="$t('SeaExport.ClearanceMethod')">
        <cargo-advance-select
          no="customsMethodPod"
          :disabled="readonly || !elementDict.customsMethodPod.writable"
          :select-type="selectTypeNames.basic_data_CustomsMode"
          :method-params="{serviceType:1}"
          filterable
          :clearable="false"
          :default-value="fbaJob.customsMethodPod"
          @parentCallBack="p=>{fbaJob.customsMethodPod=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.tradeTerm.viewable" slot="tradeTerm">
        <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
        <cargo-advance-select
          no="tradeTerm"
          :select-type="selectTypeNames.basic_data_TradeTerm"
          filterable
          :default-value="form.tradeTerm"
          :disabled="readonly || !elementDict.tradeTerm.writable"
          @parentCallBack="p=>{form.tradeTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.haulageCompany.viewable" slot="haulageCompany">
        <line-label slot="label" :class="elementDict.haulageCompany.isRequire ? 'blue' : ''" :label="elementDict.haulageCompany.label" />
        <cargo-company-select
          no="carryingCmp"
          :disabled="readonly || !elementDict.haulageCompany.writable || !form.landTransportation"
          :method-params="{truckCmp:true,active:true}"
          :default-value="form.carryingCmp||''"
          :placeholder="$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"

          @change="p=>{pm.carryingCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="isFba" :label="$t('SeaExport.EstimatedStorageReadyGoodsTime')">
        <el-date-picker
          v-model="fbaJob.preWarehousingTime"
          :disabled="readonly || !elementDict.estimatedStorageReadyGoodsTime.writable"
          no="preWarehousingTime"
          type="date"
          style="width:100%;"
          clearable
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.warehouseCmp.viewable && !isFba" slot="warehouseCmp">
        <line-label slot="label" :class="elementDict.warehouseCmp.isRequire ? 'blue' : ''" :label="elementDict.warehouseCmp.label" />
        <cargo-company-select
          no="warehouseCmp"
          :disabled="readonly || !elementDict.warehouseCmp.writable || !warehouseEabled"
          :method-params="{warehouse:true,active:true}"
          :default-value="form.warehouseCmp||''"
          :placeholder="$t('SeaExport.PleaseSelectWarehouse')"
          @change="p=>{pm.warehouseCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.warehouseName.viewable && openWarehouse" slot="warehouseName">
        <line-label slot="label" :class="elementDict.warehouseName.isRequire ? 'blue' : ''" :label="elementDict.warehouseName.label" />
        <el-select
          ref="warehouseName"
          v-model="form.warehouseName"
          no="warehouseName"
          :disabled="readonly || !elementDict.warehouseName.writable || !warehouseEabled||!form.warehouseCmp"
          :allow-create="true"
          filterable
          :clearable="true"
          @change="warehouseNameChangeHandler"
        >
          <el-option
            v-for="(item,index) in warehouseNameList"
            :key="index"
            :label="item.warehouseName"
            :value="item.warehouseName"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.backUpWarehouse.viewable" slot="backUpWarehouse">
        <line-label slot="label" :class="elementDict.backUpWarehouse.isRequire ? 'blue' : ''" :label="elementDict.backUpWarehouse.label" />
        <cargo-advance-select
          no="backUpWarehouseCmp"
          :select-type="selectTypeNames.basic_data_Company"
          :cache="false"
          :disabled="readonly || !elementDict.backUpWarehouse.writable || !backUpWarehouseEnabled"
          :default-value="form.backUpWarehouseCmp||''"
          filterable
          :static-options="backUpWarehouseCompanyList"
          :placeholder="!backUpWarehouseEnabled? $t('SeaExport.PleaseSelectBackUpWarehouse'): $t('CargoMsg.Cargo_keyWordsTip')"
          @parentCallBack="p=>{pm.backUpWarehouseCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.agentInformation && elementDict.agentInformation.viewable" slot="agentInformation">
        <line-label slot="label" :class="elementDict.agentInformation.isRequire ? 'blue' : ''" :label="elementDict.agentInformation.label" />
        <cargo-textarea v-model="form.agentInformation" no="agentInformation" type="textarea" :row="3" :disabled="readonly || !elementDict.agentInformation.writable" />
      </el-form-item>
      <el-form-item v-if="isFba" :label="$t('SeaExport.ForeignWarehouse')">
        <cargo-advance-select
          no="overseaWarehouseCode"
          :select-type="selectTypeNames.basic_data_OverseaWarehouse"
          filterable
          :method-params="{ifFba:false}"
          :clearable="false"
          tag-name="chineseName"
          :default-value="form.overseaWarehouseCode"
          :disabled="readonly || !elementDict.overseaWarehouseCode.writable"
          style="width:100%;"
          @parentCallBack="p=>{form.overseaWarehouseCode=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingTerm.viewable" slot="bookingTerm">
        <line-label slot="label" :class="elementDict.bookingTerm.isRequire ? 'blue' : ''" :label="elementDict.bookingTerm.label" />
        <el-select
          v-model="form.bookingTerm"
          no="bookingTerm"
          :disabled="readonly || !elementDict.bookingTerm.writable"
          :placeholder="readonly ? '' : $t('SeaExport.PleaseSelect')"
          clearable
        >
          <el-option
            v-for="(item,index) in bookingTerms"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.incoTerm.viewable" slot="incoTerm">
        <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
        <cargo-advance-select
          no="incoTerm"
          :select-type="selectTypeNames.basic_data_IncoTerm"
          filterable
          :default-value="form.incoTerm"
          :disabled="readonly || !elementDict.incoTerm.writable"
          @parentCallBack="p=>{form.incoTerm=p.value}"
        />
      </el-form-item>
      <!--港前商务负责人-->
      <el-form-item v-if="elementDict.prePortPlanner && elementDict.prePortPlanner.viewable" slot="prePortPlanner">
        <line-label slot="label" :class="elementDict.prePortPlanner.isRequire ? 'blue' : ''" :label="elementDict.prePortPlanner.label" />
        <cargo-user-select
          no="prePortPlanner"
          class="input2"
          :disabled="readonly"
          :method-params="{category:'role',shape:'sealine',officeId:$store.getters.currentOfficeId}"
          :default-value="form.prePortPlanner||''"
          placeholder=" "
          @change="p=>{pm.prePortPlannerChangeHandler(p)}"
        />
      </el-form-item>
      <!--尾程商务负责人-->
      <el-form-item v-if="elementDict.lastMilePlanner && elementDict.lastMilePlanner.viewable" slot="lastMilePlanner">
        <line-label slot="label" :class="elementDict.lastMilePlanner.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlanner.label" />
        <cargo-user-select
          no="lastMilePlanner"
          class="input2"
          :disabled="readonly"
          :method-params="{category:'role',shape:'sealine',officeId:$store.getters.currentOfficeId}"
          :default-value="form.lastMilePlanner||''"
          placeholder=" "
          @change="p=>{pm.lastMilePlannerChangeHandler(p)}"
        />
      </el-form-item>
      <!--港前商务负责人部门-->
      <el-form-item v-if="elementDict.prePortPlannerDepartment && elementDict.prePortPlannerDepartment.visible" slot="prePortPlannerDepartment">
        <line-label slot="label" :class="elementDict.prePortPlannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.prePortPlannerDepartment.label" />
        <cargo-department-select
          no="prePortPlannerDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(form.prePortPlannerOffice)"
          :enables="true"
          :department-id="Number(form.prePortPlannerDepartment)"
          @change="p=>{form.prePortPlannerDepartment=p.value}"
        />
      </el-form-item>
      <!--尾程商务负责人部门-->
      <el-form-item v-if="elementDict.lastMilePlannerDepartment && elementDict.lastMilePlannerDepartment.visible" slot="lastMilePlannerDepartment">
        <line-label slot="label" :class="elementDict.lastMilePlannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlannerDepartment.label" />
        <cargo-department-select
          no="lastMilePlannerDepartment"
          class="input2"
          :disabled="readonly"
          :office-id="Number(form.lastMilePlannerOffice)"
          :enables="true"
          :department-id="Number(form.lastMilePlannerDepartment)"
          @change="p=>{form.lastMilePlannerDepartment=p.value}"
        />
      </el-form-item>
      <!--港前商务负责人公司-->
      <el-form-item v-if="elementDict.prePortPlannerOffice && elementDict.prePortPlannerOffice.visible" slot="prePortPlannerOffice">
        <line-label slot="label" :class="elementDict.prePortPlannerOffice.isRequire ? 'blue' : ''" :label="elementDict.prePortPlannerOffice.label" />
        <cargo-advance-select
          no="prePortPlannerOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="form.prePortPlannerOffice||''"
          @parentCallBack="p=>{form.prePortPlannerOffice=p.value}"
        />
      </el-form-item>
      <!--尾程商务负责人公司-->
      <el-form-item v-if="elementDict.lastMilePlannerOffice && elementDict.lastMilePlannerOffice.visible" slot="lastMilePlannerOffice">
        <line-label slot="label" :class="elementDict.lastMilePlannerOffice.isRequire ? 'blue' : ''" :label="elementDict.lastMilePlannerOffice.label" />
        <cargo-advance-select
          no="lastMilePlannerOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="form.lastMilePlannerOffice||''"
          @parentCallBack="p=>{form.lastMilePlannerOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtWhs.viewable" slot="txtWhs">
        <line-label slot="label" :class="elementDict.txtWhs.isRequire ? 'blue' : ''" :label="elementDict.txtWhs.label" />
        <el-input
          no="txtWhs"
          :disabled="true"
          type="textarea"
          :rows="2"
          :value="txtWhs"
          :placeholder="$t('Message.NoStorageInfo')"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.viewable" slot="remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <el-input
          v-model="form.remarks"
          :disabled="readonly || !elementDict.remarks.writable"
          no="remarks"
          type="textarea"
          :rows="2"
          @dblclick.native="showAdvanceTextDialog(elementDict.remarks.label,form.remarks,val=>{form.remarks=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.businessTags.viewable" slot="businessTags" label=" ">
        <el-checkbox
          v-model="form.allocation"
          :disabled="readonly || !elementDict.businessTags.writable"
          no="allocation"
          style="margin: 0; padding-right: 10px"
        >{{ 'Allocation' }}
        </el-checkbox>
        <el-checkbox
          v-model="form.availableCabinSpace"
          :disabled="readonly || !elementDict.businessTags.writable"
          no="availableCabinSpace"
        >{{ $t('CargoMsg.Cargo_AvailableCabinSpace') }}
        </el-checkbox>
      </el-form-item>
      <booking-sea-eq-data-grid
        v-if="elementDict.seaEq.viewable"
        slot="seaEq"
        no="seaEqList"
        :value="seaEqList"
        :container-load-type="form.containerLoadType"
        :is-edit="isEdit && elementDict.seaEq.writable"
        :job="form"
        style="width:100%"
        @cellChange="()=>{pm.dgSeaEqItemEditEndHandler()}"
        @eqQuantityChange="eqQuantityChangeHandler"
      />
      <el-form-item v-if="elementDict.quantityConsignActual.viewable" slot="quantityConsignActual">
        <line-label slot="label" :class="elementDict.quantityConsignActual.isRequire ? 'blue' : ''" :label="elementDict.quantityConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.quantityContract"
            no="quantityContract"
            :precision="0"
            :min="0"
            :disabled="readonly || !elementDict.quantityConsignActual.writable || !isJydEditJobFields"
            @change="SEUtils.changeQWCRule(()=>{form.quantityActual=form.quantityContract});pm.txtPackingChangeHandler()"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="form.quantityActual"
            no="quantityActual"
            :precision="0"
            :disabled="readonly || !elementDict.quantityConsignActual.writable || !isJydEditJobFields"
            :min="0"
            @change="SEUtils.changeQWCRule(null,()=>{form.quantityContract=form.quantityActual})"
          />
          <span>PCS</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.weightConsignActual.viewable" slot="weightConsignActual">
        <line-label slot="label" :class="elementDict.weightConsignActual.isRequire ? 'blue' : ''" :label="elementDict.weightConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.weightContract"
            no="weightContract"
            :precision="3"
            :min="0"
            :disabled="readonly || !elementDict.weightConsignActual.writable || !isJydEditJobFields"
            @change="weightContractChange"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="form.weightActual"
            no="weightActual"
            :precision="3"
            :disabled="readonly || !elementDict.weightConsignActual.writable || !isJydEditJobFields"
            :min="0"
            @change="weightActualChange"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cubageConsignActual.viewable" slot="cubageConsignActual">
        <line-label slot="label" :class="elementDict.cubageConsignActual.isRequire ? 'blue' : ''" :label="elementDict.cubageConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.cubageContract"
            no="cubageContract"
            :precision="3"
            :min="0"
            :disabled="readonly || !elementDict.cubageConsignActual.writable || !cubageActualEnabled || !isJydEditJobFields"
            @change="cubageContractChange"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            v-model="form.cubageActual"
            no="cubageActual"
            :precision="3"
            :disabled="readonly || !elementDict.cubageConsignActual.writable || !cubageActualEnabled || !isJydEditJobFields"
            :min="0"
            @change="cubageActualChange"
          />
          <span>CBM</span>
        </div>
      </el-form-item>
      <el-form-item v-if="isFba" label-width="0">
        <div style="display: flex;justify-content: space-around">
          <el-checkbox v-model="fbaJob.electric" :disabled="readonly" style="margin-right: 10px;margin-left: 20px;">{{ $t('SeaExport.WithElectricity') }}</el-checkbox>
          <el-checkbox v-model="fbaJob.magnetic" :disabled="readonly" style="margin-right: 10px;">{{ $t('SeaExport.WithMagnetism') }}</el-checkbox>
          <el-checkbox v-model="fbaJob.powdery" :disabled="readonly" style="margin-right: 10px;">{{ $t('SeaExport.Powder') }}</el-checkbox>
          <el-checkbox v-model="fbaJob.liquid" :disabled="readonly" style="margin-right: 10px;">{{ $t('SeaExport.Liquid') }}</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item v-show="elementDict.packing.viewable" slot="packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          ref="packing"
          no="packing"
          :default-value="form.packing"
          :disabled="readonly || !elementDict.packing.writable"
          style="width:100%;"
          @change="p=>{form.packing=p.value;pm.txtPackingChangeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.chargeWeight.viewable && !isFba" slot="chargeWeight">
        <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
        <div style="display: flex">
          <el-input-number
            no="chargeWeight"
            :disabled="readonly || !elementDict.chargeWeight.writable"
            :value="form.chargeWeight||undefined"
            :precision="3"
            :min="0"
            :controls="false"
            style="flex:1"
            @input="val=>{form.chargeWeight=val;context.reloadCharge = true}"
          />&nbsp;
          <span>{{ isFba ? 'KGS' : 'M/T' }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoChineseName.viewable" slot="cargoChineseName">
        <div slot="label">
          <line-label :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
          <br>
          <el-button
            v-show="isEdit && elementDict.cargoChineseName.writable"
            no="MergingTickets"
            :disabled="readonly || !elementDict.cargoChineseName.writable"
            type="primary"
            @click="pm.mergeLclCargoDocInfo('cargoChineseName', form)"
          >{{ $t('SeaExport.MergingTickets') }}</el-button>
        </div>
        <div style="position:relative">
          <el-input
            v-model="form.cargoChineseName"
            :disabled="readonly || !elementDict.cargoChineseName.writable"
            type="textarea"
            :rows="3"
            no="cargoChineseName"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),form.cargoChineseName,val=>{form.cargoChineseName=val})"
          />
          <char-count :value="form.cargoChineseName" />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoEnglishName.viewable" slot="cargoEnglishName">
        <div slot="label">
          <line-label :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <br>
          <el-button
            v-show="isEdit && elementDict.cargoEnglishName.writable"
            type="primary"
            no="EnglishDescriptionOfGoods"
            @click="pm.mergeLclCargoDocInfo('cargoEnglishName', form)"
          >{{ $t('SeaExport.MergingTickets') }}</el-button>
        </div>
        <special-character-tip :texts="specialCharCheck.cargoEnglishName">
          <div style="position:relative">
            <el-input
              v-model="form.cargoEnglishName"
              no="cargoEnglishName"
              :disabled="readonly || !elementDict.cargoEnglishName.writable"
              type="textarea"
              :rows="3"
              @input="handleInputCargoEnglishName"
              @dblclick.native="showAdvanceTextDialog(elementDict.cargoEnglishName.label,form.cargoEnglishName,val=>{form.cargoEnglishName=val},isUppercaseByConfig,{autoUppercase:isUppercaseByConfig})"
            />
            <char-count :value="form.cargoEnglishName" />
          </div>
        </special-character-tip>
      </el-form-item>
      <el-form-item v-if="elementDict.mark.viewable" slot="mark">
        <div slot="label">
          <line-label :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
          <br>
          <el-button
            v-show="isEdit && elementDict.mark.writable"
            style="margin-left: 10px;"
            no="Marks"
            type="primary"
            @click="pm.mergeLclCargoDocInfo('mark', form)"
          >{{ $t('SeaExport.MergingTickets') }}</el-button>
        </div>
        <special-character-tip :texts="specialCharCheck.mark">
          <div style="position:relative">
            <el-input
              v-model="form.mark"
              :disabled="readonly || !elementDict.mark.writable"
              no="mark"
              type="textarea"
              :rows="3"
              @input="handleInputMark"
              @dblclick.native="showAdvanceTextDialog(elementDict.mark.label,form.mark,val=>{form.mark=val},isUppercaseByConfig,{autoUppercase:isUppercaseByConfig})"
            />
            <char-count :value="form.mark" />
          </div>
        </special-character-tip>
      </el-form-item>
      <template v-if="elementDict.cargoCode.viewable" slot="cargoCode">
        <el-form-item class="custom">
          <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
          <cargo-advance-select
            no="cargoCode"
            :select-type="selectTypeNames.basic_data_CargoInformation"
            :disabled="readonly || !elementDict.cargoCode.writable"
            filterable
            :clearable="true"
            :default-value="form.cargoCode"
            :allow-create="false"
            @parentCallBack="p=>{pm.cargoCodeChange(p.value)}"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.cargoName"
            no="cargoName"
            :disabled="readonly || !elementDict.cargoCode.writable || !(isEdit && form.cargoCode)"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.salesChannel.viewable" slot="salesChannel">
        <line-label slot="label" :class="elementDict.salesChannel.isRequire ? 'blue' : ''" :label="elementDict.salesChannel.label" />
        <el-input
          :value="form.salesChannel"
          :disabled="true"
        />
      </el-form-item>
      <!--CARGO-18489 新增“渠道单号”字段,显示渠道单号时隐藏委托关联号-->
      <el-form-item v-if="elementDict.channelNo.viewable" slot="channelNo">
        <line-label slot="label" :class="elementDict.channelNo.isRequire ? 'blue' : ''" :label="elementDict.channelNo.label" />
        <el-input :value="form.channelNo" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.trustFromJob && elementDict.trustFromJob.viewable" slot="trustFromJob">
        <line-label slot="label" :class="elementDict.trustFromJob.isRequire ? 'blue' : ''" :label="elementDict.trustFromJob.label" />
        <el-input :value="form.trustFromJob" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.relatedJob && elementDict.relatedJob.viewable" slot="relatedJob">
        <line-label slot="label" :class="elementDict.relatedJob.isRequire ? 'blue' : ''" :label="elementDict.relatedJob.label" />
        <el-input :value="form.relatedJob" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.salesCompany.viewable" slot="salesCompany">
        <line-label slot="label" :class="elementDict.salesCompany.isRequire && form.containerLoadType !== LCL_CARGO_TYPE.code ? 'blue' : ''" :label="elementDict.salesCompany.label" />
        <el-input
          :value="txtSalesOffice"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.sales.viewable" slot="sales">
        <line-label slot="label" :class="elementDict.sales.isRequire && form.containerLoadType !== LCL_CARGO_TYPE.code ? 'blue' : ''" :label="elementDict.sales.label" />
        <cargo-user-select
          ref="sales"
          no="sales"
          :disabled="readonly || !elementDict.sales.writable"
          :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
          :default-value="form.sales||''"
          :merge-load="true"
          @change="p=>{pm.txtSalesChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSalesId.viewable" slot="cargoSalesId">
        <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
        <cargo-user-select
          no="cargoSalesId"
          :method-params="{category:'role',shape:'salesOfGoods'}"
          :default-value="form.cargoSalesId||''"
          :disabled="readonly || !elementDict.cargoSalesId.writable"
          :merge-load="true"
          :static-options="cargoSalesList"
          @change="p=>{form.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesDepartment.viewable" slot="salesDepartment">
        <line-label slot="label" :class="elementDict.salesDepartment.isRequire && form.containerLoadType !== LCL_CARGO_TYPE.code ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
        <cargo-department-new-select
          no="salesOffice"
          :disabled="readonly || !elementDict.sales.writable || !form.sales"
          :sales-id="Number(form.sales)"
          :office-id="form.salesOffice"
          :enables="true"
          :department-id="Number(form.salesDepartment)"
          @change="p=>{form.salesDepartment=p.value;pm.departmentChargeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opOffice.viewable" slot="opOffice">
        <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
        <cargo-office-select
          no="opOffice"
          :disabled="readonly || !elementDict.opOffice.writable || (!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
          :is-regional-commission="isRegionalCommission"
          :office-id="Number(form.opOffice)"
          @change="p=>{form.opOffice=p.value;form.opDepartment=0;opOfficeChargeHandler();contractRuleFieldChange(form.customerId, form.designationAgent)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opDepartment.viewable" slot="opDepartment">
        <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
        <cargo-department-select
          no="opDepartment"
          :disabled="readonly || !elementDict.opDepartment.writable || pm.isWithinCloseAccountDate"
          :office-id="Number(form.opOffice)"
          :enables="true"
          :department-id="Number(form.opDepartment)"
          @change="p=>{form.opDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.op.viewable" slot="op">
        <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
        <cargo-user-select
          ref="op"
          no="op"
          :disabled="readonly || !elementDict.op.writable || !opEabled"
          :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
          :default-value="form.op||''"
          :merge-load="true"
          :static-options="userPortRoleData.op"
          @change="p=>{pm.txtOPChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrOffice.viewable" slot="csrOffice">
        <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
        <cargo-office-select
          no="csrOffice"
          :disabled="true"
          :office-id="Number(form.csrOffice)"
          @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrDepartment.viewable" slot="csrDepartment">
        <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
        <cargo-department-select
          no="csrDepartment"
          :office-id="Number(form.csrOffice)"
          :enables="true"
          :department-id="Number(form.csrDepartment)"
          :disabled="readonly || !elementDict.csrDepartment.writable"
          @change="p=>{form.csrDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csr.viewable" slot="csr">
        <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
        <cargo-user-select
          no="csr"
          :method-params="{officeId:pm.isEntrustOrder||form.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
          :default-value="form.csr||''"
          :disabled="readonly || !elementDict.csr.writable"
          :merge-load="true"
          :static-options="userPortRoleData.csr"
          @change="p=>{pm.csrChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.siteOP.viewable" slot="siteOP">
        <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
        <cargo-user-select
          :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
          :default-value="form.siteOP||''"
          :disabled="readonly || !elementDict.siteOP.writable"
          :static-options="userPortRoleData.siteOp"
          @change="p=>{JobUtils.siteOpChangeHandler(form, p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.overseaOp.viewable" slot="overseaOp">
        <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
        <cargo-user-select
          no="overseaOp"
          :default-value="form.overseaOp||''"
          :disabled="readonly || !elementDict.overseaOp.writable"
          :method-params="{category:'role',shape:'overseaOp'}"
          :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaOpList)"
          :merge-load="true"
          @change="p=>{pm.overseaOpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcOffice.viewable" slot="dcOffice">
        <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
        <cargo-office-select
          no="dcOffice"
          :disabled="true"
          :office-id="Number(form.dcOffice)"
          @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcDepartment.viewable" slot="dcDepartment">
        <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
        <cargo-department-select
          no="dcDepartment"
          :office-id="Number(form.dcOffice)"
          :enables="true"
          :department-id="Number(form.dcDepartment)"
          :disabled="readonly || !elementDict.dcDepartment.writable"
          @change="p=>{form.dcDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dc.viewable" slot="dc">
        <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
        <cargo-user-select
          no="dc"
          :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
          :default-value="form.dc||''"
          :disabled="readonly || !elementDict.dc.writable"
          :merge-load="true"
          :static-options="userPortRoleData.doc"
          @change="p=>{pm.dcChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.viewable" slot="plannerOffice">
        <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
        <cargo-office-select
          no="plannerOffice"
          :disabled="true"
          :office-id="Number(form.plannerOffice)"
          @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.viewable" slot="plannerDepartment">
        <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
        <cargo-department-select
          no="plannerDepartment"
          :office-id="Number(form.plannerOffice)"
          :enables="true"
          :department-id="Number(form.plannerDepartment)"
          :disabled="readonly || !elementDict.plannerDepartment.writable"
          @change="p=>{form.plannerDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.planner.viewable" slot="planner">
        <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
        <cargo-user-select
          no="planner"
          :method-params="{category:'role',shape:'sealine'}"
          :default-value="form.planner||''"
          :disabled="readonly || !elementDict.planner.writable"
          :merge-load="true"
          :static-options="userPortRoleData.seaLine"
          @change="p=>{pm.txtPlannerChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.userDefinedRoleId1.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId1">
        <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
        <cargo-user-select
          ref="userDefinedRoleId1"
          no="userDefinedRoleId1"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
          :default-value="form.userDefinedRoleId1||''"
          :disabled="readonly || !elementDict.userDefinedRoleId1.writable"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole1"
          @change="p=>{pm.userDefinedRoleId1Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.userDefinedRoleId2.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId2">
        <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
        <cargo-user-select
          ref="userDefinedRoleId2"
          no="userDefinedRoleId2"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
          :default-value="form.userDefinedRoleId2||''"
          :disabled="readonly || !elementDict.userDefinedRoleId2.writable"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole2"
          @change="p=>{pm.userDefinedRoleId2Handler(p)}"
        />
      </el-form-item>
      <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.viewable && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
        <micro-app
          name="child-user-defined-role-se-master-userDefinedRoleId3"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChangeUI"
        />
      </div>
      <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.viewable && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
        <micro-app
          name="child-user-defined-role-se-master-userDefinedRoleId4"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChangeUI"
        />
      </div> -->
      <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId3">
        <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
        <cargo-user-select
          ref="userDefinedRoleId3"
          no="userDefinedRoleId3"
          :disabled="readonly || !elementDict.userDefinedRoleId3.writable"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
          :default-value="form.userDefinedRoleId3||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole3"
          @change="p=>{pm.userDefinedRoleId3Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId4">
        <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
        <cargo-user-select
          ref="userDefinedRoleId4"
          no="userDefinedRoleId4"
          :disabled="readonly || !elementDict.userDefinedRoleId4.writable"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
          :default-value="form.userDefinedRoleId4||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole4"
          @change="p=>{pm.userDefinedRoleId4Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId5">
        <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
        <cargo-user-select
          ref="userDefinedRoleId5"
          no="userDefinedRoleId5"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
          :default-value="form.userDefinedRoleId5||''"
          :disabled="readonly || !elementDict.userDefinedRoleId5.writable"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId5Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId6">
        <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
        <cargo-user-select
          ref="userDefinedRoleId6"
          no="userDefinedRoleId6"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
          :default-value="form.userDefinedRoleId6||''"
          :disabled="readonly || !elementDict.userDefinedRoleId6.writable"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId6Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId7">
        <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
        <cargo-user-select
          ref="userDefinedRoleId7"
          no="userDefinedRoleId7"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
          :default-value="form.userDefinedRoleId7||''"
          :disabled="readonly || !elementDict.userDefinedRoleId7.writable"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId7Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
        <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
        <cargo-user-select
          ref="userDefinedRoleId8"
          no="userDefinedRoleId8"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
          :default-multiple-value="toNumArray(form.userDefinedRoleId8)"
          :multiple="true"
          :merge-load="true"
          :placeholder="readonly ? ' ' : ''"
          @change="p=>{form.userDefinedRoleId8=toTxt(p.value)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField1.viewable" slot="userDefinedField1">
        <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
        <el-input
          v-model="form.userDefinedField1"
          :disabled="readonly || !elementDict.userDefinedField1.writable"
          no="userDefinedField1"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,form.userDefinedField1,val=>{form.userDefinedField1=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField2.viewable" slot="userDefinedField2">
        <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
        <el-input
          v-model="form.userDefinedField2"
          :disabled="readonly || !elementDict.userDefinedField2.writable"
          no="userDefinedField2"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,form.userDefinedField2,val=>{form.userDefinedField2=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField3.viewable" slot="userDefinedField3">
        <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
        <el-input
          v-model="form.userDefinedField3"
          :disabled="readonly || !elementDict.userDefinedField3.writable"
          no="userDefinedField3"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,form.userDefinedField3,val=>{form.userDefinedField3=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField4.viewable" slot="userDefinedField4">
        <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
        <el-input
          v-model="form.userDefinedField4"
          :disabled="readonly || !elementDict.userDefinedField4.writable"
          no="userDefinedField4"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,form.userDefinedField4,val=>{form.userDefinedField4=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.exportControlledProduct && elementDict.exportControlledProduct.viewable" slot="exportControlledProduct">
        <line-label slot="label" :class="elementDict.exportControlledProduct.isRequire ? 'blue' : ''" :label="elementDict.exportControlledProduct.label" />
        <el-select
          v-model="form.exportControlledProduct"
          no="exportControlledProduct"
          :disabled="readonly || !elementDict.exportControlledProduct.writable"
          :placeholder="''"
          :clearable="true"
          size="mini"
        >
          <el-option
            v-for="(item,index) in EXPORT_CONTROLLED_PRODUCT"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.viewable" slot="taxNature">
        <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
        <el-select
          v-model="form.taxNature"
          :disabled="readonly || !elementDict.taxNature.writable"
          no="taxNature"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in TAX_NATURES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-if="elementDict.rateType && elementDict.rateType.viewable" slot="rateType">
        <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
        <el-select
          v-model="form.rateType"
          :disabled="readonly || !elementDict.rateType.writable"
          no="rateType"
          clearable
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in rateType"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-if="elementDict.loadingAgentId && elementDict.loadingAgentId.viewable" slot="loadingAgentId">
        <line-label slot="label" :class="elementDict.loadingAgentId.isRequire ? 'blue' : ''" :label="elementDict.loadingAgentId.label" />
        <cargo-company-select
          :method-params="{localAgent:true,active: true}"
          :disabled="readonly || !elementDict.loadingAgentId.writable"
          no="loadingAgentId"
          :default-value="form.loadingAgentId||''"
          :data-filter-function="JobUtils.loadingAgentIdFilter"
          :tag-name="isZh ? 'chineseName' : 'englishName'"
          @change="p=>{form.loadingAgentId = p.value}"
        />
      </el-form-item>
      <div slot="ticketsInfo" class="section" style="width: 100%;">
        <div class="title">
          {{ $t('SeaExport.TicketsInfo') }}
          <div ref="division" class="division" :style="{height:divisionHeight+'px'}" @mousedown="divisionEnabled=true">
            <div class="line" style="margin-top:2px" />
            <div class="line" />
          </div>
        </div>
        <div style="display:flex;flex-direction:column;margin-bottom: 5px;line-height: 28px;">
          <div style="padding:5px 0">
            <span style="margin-right: 5px;">{{ $t('SeaExport.TotalTickets') }}:</span><span style="margin-right: 5px;">{{ form.lclSlaves.length }}</span>
            <div v-show="readonly&&viewSource==='bookingWorkspace'" style="display: inline-flex;">
              <el-button
                no="NewTickets"
                :disabled="!isSeaExport || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnCreateClickHandler"
              >{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button
                no="EditTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnLcLEditClickHandler"
              >{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button
                no="AddTickets"
                :disabled="!isSeaExport || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnImportLclClickHandler"
              >{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button
                no="RemoveTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="danger"
                @click="pm.btnRemoveBatchClickHandler()"
              >{{ $t('SeaExport.RemoveTickets') }}</el-button>
              <el-button
                v-permission="['button_fmBookingNew_deleteSmallTicket']"
                no="DeleteTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="danger"
                @click="btnRemoveClickHandler"
              >{{ $t('SeaExport.DeleteTickets') }}</el-button>
            </div>
          </div>
          <div ref="slaveDiv" style="display: flex;">
            <cargo-ag-grid
              config-module="130125"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>
        </div>
      </div>
    </tab-booking-master-UICustom-layout>
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-se-lcl-dialog
      :visible.sync="querySELclDialog.visible"
      :job="form"
      @callback="rows=>{pm.slavedAddedHandler(rows)}"
    />
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="ticketDialog"
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number v-model="ticketDialog.value" :precision="0" :min="1" :max="50" :controls="false" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="ticketDialogConfirm" type="primary" @click="toAddTicket">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="ticketDialogCancel" type="primary" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 联系人弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="ContactPerson"
      :visible.sync="contactDialog.visible"
      :title="$t('SeaExport.ContactPerson')"
      width="400px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        label-position="right"
        label-width="100px"
      >
        <el-form-item :label="$t('SeaExport.ContactPerson')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.contactPerson"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Role')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.role"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.telephone"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Mobile')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.mobile"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.fax"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Email')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.email"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.remarks"
            type="textarea"
            :rows="3"
            style="width: 170px;"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="advanceTextDialogConfirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { BC_CARGO_TYPE, LCL_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'
import tabBookingMasterUICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMasterUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabBookingMaster from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMaster'
import StrUtils from '@/utils/StrUtils'
import cargoInput from '@/components/Cargo/Common/cargoInput.vue'
import microApp from '@micro-zoe/micro-app'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { toNumArray, toTxt } from '@/utils/commonUtil'
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea.vue'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'TabBookingMasterUICustom',
  components: { cargoTextarea, cargoInput, tabBookingMasterUICustomLayout },
  extends: tabBookingMaster,
  data() {
    return {
      TYPE_NAMES,
      LCL_CARGO_TYPE,
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.form ? this.form.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      },
      scacList: [],
      carrierScacEdit: false
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    'form.exportControlledProduct': {
      immediate: true,
      handler(val) {
        if (val === 0) {
          this.form.exportControlledProduct = ''
        }
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        const pageType = this.$route.name === 'BookingVerify' ? UICustomConstants.SEA_VERIFY_BOOKING_BASIC : UICustomConstants.SEA_BOOKING_BASIC
        UICustomUtil.handleViewAndWrite(pageType, this.elementDict, row, true)
        if (!row.uuid) {
          this.onFieldChange('etd')
        }
      }
      this.scacList = await JobUtils.getScacList(this.form.carrierScac)
    },
    loadPageConfig() {
      const pageType = this.$route.name === 'BookingVerify' ? UICustomConstants.SEA_VERIFY_BOOKING_BASIC : UICustomConstants.SEA_BOOKING_BASIC
      const pageConfig = UICustomUtil.getPageConfig(pageType, this.$store.getters.currentOfficeId, true)
      this.elementBlocks = pageConfig.elementBlocks
      this.elementDict = pageConfig.elementDict
      this.fieldDict = pageConfig.fieldDict
      this.carrierScacEdit = JobUtils.checkCarrierScacEdit(this.elementDict)
    },
    async getSubmitData() {
      const form = this.form
      for (const key in this.elementDict) {
        const element = this.elementDict[key]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          if (fieldName === 'customerId' || fieldName === 'customerProperty' || fieldName === 'customerContact') {
            if (form.containerLoadType !== BC_CARGO_TYPE.code) {
              continue
            }
          }
          if (fieldName === 'customerId' && form.containerLoadType === BC_CARGO_TYPE.code) {
            continue
          }
          if (fieldName === 'agentRefNo') {
            if (form.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
              continue
            }
          }
          if (fieldName === 'projectName' || fieldName === 'projectBatch') {
            continue
          }
          if (['paymentTermHBL', 'freightTermHBL', 'measurements', 'salePriceRemarks', 'freeDemurrage', 'hsCode', 'freeDetention', 'customsAreaApplication'].includes(fieldName)) {
            continue
          }
          if (form.containerLoadType === LCL_CARGO_TYPE.code) {
            if (fieldName === 'sales' || fieldName === 'salesDepartment') {
              continue
            }
          }
          if (fieldName === 'userDefinedRoleId1' || fieldName === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (fieldName.startsWith('shipper') || fieldName.startsWith('consignee') || fieldName.startsWith('notify') || fieldName === 'alsoNotify') {
            continue
          }
          if (fieldName === 'transferPortCode') {
            if (form.transfering && StrUtils.isEmpty(form.transferPortCode)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
          } else if (fieldName === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
          } else if (fieldName === 'taxNature') {
            if (form[fieldName] === '' || form[fieldName] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
          }
        }
      }
      if (this.elementDict.seaEq && this.elementDict.seaEq.viewable && this.elementDict.seaEq.writable && this.elementDict.seaEq.isRequire) {
        if (!this.seaEqList || this.seaEqList.length === 0) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'tabBookingMaster')
        }
        for (const seaEq of this.seaEqList) {
          if (!seaEq.eqQuantity) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.ContainerAmount')]), 'tabBookingMaster')
          }
        }
      }
      if (this.elementDict.haulageCompany && this.elementDict.haulageCompany.viewable && this.elementDict.haulageCompany.writable && this.elementDict.haulageCompany.isRequire) {
        if (!this.form.carryingCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.haulageCompany.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.warehouseCmp && this.elementDict.warehouseCmp.viewable && this.elementDict.warehouseCmp.writable && this.elementDict.warehouseCmp.isRequire) {
        if (!this.form.warehouseCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseCmp.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.warehouseName && this.elementDict.warehouseName.viewable && this.elementDict.warehouseName.writable && this.elementDict.warehouseName.isRequire && this.openWarehouse) {
        if (StrUtils.isEmpty(this.form.warehouseName)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseName.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.backUpWarehouse && this.elementDict.backUpWarehouse.viewable && this.elementDict.backUpWarehouse.isRequire) {
        if (!form.backUpWarehouseCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.backUpWarehouse.label]), 'tabBookingMaster')
        }
      }
      this.superFunction = this.$options.extends.methods.getSubmitData
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.form.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-se-master-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.form.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-se-master-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.form.userDefinedRoleId3 = e.detail.data.fieldData
            this.pm.userDefinedRoleId3Handler(this.form.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.form.userDefinedRoleId4 = e.detail.data.fieldData
            this.pm.userDefinedRoleId4Handler(this.form.userDefinedRoleId4)
          }
        }
      }
    },
    onFieldChange(fieldName) {
      if (this.$route.name === 'BookingVerify') {
        // UICustomUtil.handleFieldChange(UICustomConstants.SEA_VERIFY_BOOKING_MODULE, UICustomConstants.SEA_VERIFY_BOOKING_BASIC, this.form, fieldName, this.context.modifiedData)
      } else {
        UICustomUtil.handleFieldChange(UICustomConstants.SEA_BOOKING_MODULE, UICustomConstants.SEA_BOOKING_BASIC, this.form, fieldName, this.context.modifiedData)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-item-label {
    .el-form-item {
      /deep/.el-form-item__label {
        width: 105px !important;
      }
      /deep/.el-form-item__content {
        margin-left: 105px !important;
      }
    }
  }
  .form-item-label-ja {
    min-width: 335px;
    .el-form-item {
      /deep/.el-form-item__label {
        width: 130px !important;
      }
      /deep/.el-form-item__content {
        margin-left: 130px !important;
      }
    }
  }
</style>

<style scoped lang="scss">
.division {
  display: inline-block;
  width: 18px;
  margin-left: calc(40%);
  padding: 1px 0;
  cursor: ns-resize;
}
.division .line {
  width: 100%;
  height: 0px;
  margin-bottom: 1px;
  border-bottom: 2px solid #bdbdbd;
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
